import { useState } from "react";
import { useTranslation } from "react-i18next";
import proImg from "../../assets/images/misc/billet-2.webp";

function BilletTab() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"products" | "capacity">("products");

  const productPoints = t("the_content_of_billet_product", { returnObjects: true }) as string[];

  return (
    <section className="product-tab-section">
      <div className="container">
        <span className="page-section-label">{t("Billet")}</span>
        <h2 className="inner-page-heading">{t("Billets- (Smelting Plant) Steel Billets")}</h2>
        <p className="product-tab-intro">{t("billet-info")}</p>

        {/* Tab navigation */}
        <div className="product-tabs-nav">
          <button
            type="button"
            className={`product-tab-btn${activeTab === "products" ? " active" : ""}`}
            onClick={() => setActiveTab("products")}
          >
            {t("Products")}
          </button>
          <button
            type="button"
            className={`product-tab-btn${activeTab === "capacity" ? " active" : ""}`}
            onClick={() => setActiveTab("capacity")}
          >
            {t("Productive Capacity")}
          </button>
        </div>

        {/* Products panel */}
        <div className={`product-tab-panel${activeTab === "products" ? " active" : ""}`}>
          <ul className="product-tab-list">
            {productPoints.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
          <img src={proImg} alt="Steel Billet" className="product-tab-img" />
        </div>

        {/* Productive Capacity panel */}
        <div className={`product-tab-panel${activeTab === "capacity" ? " active" : ""}`}>
          <p className="product-tab-intro">
            {t("The actual productivity capacity of smelting plant is 135,000 tons annually")}
          </p>
          <p className="product-tab-intro">
            {t("Almadina Steel aims to enhance the productive capacity up to 300,000 tons annually")}
          </p>
          <img src={proImg} alt="Steel Billet" className="product-tab-img" />
        </div>
      </div>
    </section>
  );
}

export default BilletTab;
